import { Vec3 } from 'playcanvas';

import { getActiveLookThroughController } from './camera-motion-controller';
import { Events } from './events';
import { sampleActiveSceneCameraLookThroughPose } from './scene-camera';

const registerCameraPlaybackEvents = (events: Events) => {
    const resolvePose = (frame: number) => {
        const cameraMotionController = getActiveLookThroughController();
        if (cameraMotionController) {
            return cameraMotionController.sampleLookThroughPose(frame);
        }

        const sceneCameraPose = sampleActiveSceneCameraLookThroughPose(frame);
        if (sceneCameraPose) {
            return sceneCameraPose;
        }

        return events.invoke('camera.animTrack.samplePose', frame) as { position: Vec3; target: Vec3 } | null;
    };

    const applyPlaybackPose = (frame: number) => {
        if (events.invoke('reconstructionTimeline.followCameraActive') === true) {
            return;
        }

        const pose = resolvePose(frame);
        if (pose) {
            events.fire('camera.setPose', pose, 0);
        }
    };

    const refresh = () => {
        const time = events.invoke('timeline.time');
        const frame = events.invoke('timeline.frame');
        const sampleTime = (typeof time === 'number' && Number.isFinite(time)) ? time : frame;
        if (typeof sampleTime === 'number' && Number.isFinite(sampleTime)) {
            applyPlaybackPose(sampleTime);
        }
    };

    events.on('timeline.time', (time: number) => {
        applyPlaybackPose(time);
    });

    events.on('timeline.frame', (frame: number) => {
        if (events.invoke('timeline.playing') === true) {
            return;
        }

        applyPlaybackPose(frame);
    });

    events.on('cameraPlayback.refresh', () => {
        refresh();
    });
};

export { registerCameraPlaybackEvents };